"use client";

import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { fetchConfig } from "./fetchConfig";
import { getClientDomain } from "./useFetchUnits";
import { Config } from "src/types";


export const useFetchCompanyInfo = (
  componentName?: string
): UseQueryResult<Config, Error> => {
  let companyIdentifier: string;

  try {
    companyIdentifier = getClientDomain("fetch company info");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(
      `Failed to get client domain in useFetchCompanyInfo${
        componentName ? ` called from ${componentName}` : ""
      }:`,
      error.message
    );
    // fallback or throw, depending on your needs
    companyIdentifier = typeof window !== "undefined" ? window.location.hostname : "";
  }

  return useQuery({
    queryKey: ["companyInfo"],
    queryFn: async () => {
      try {
        return await fetchConfig(companyIdentifier);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        console.error(
          `fetchConfig failed in useFetchCompanyInfo${
            componentName ? ` called from ${componentName}` : ""
          }:`,
          error.message
        );
        throw error; // rethrow so react-query knows it failed
      }
    },
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
